









































import { Component, Prop, Vue } from "vue-property-decorator";
import { COLOR } from "@/consts/consts";

@Component
export default class FourPlayer extends Vue {
  @Prop() private cards!: Array<any>;
  selected = "";
  COLOR = COLOR;

  get cardsList() {
    return [
      {
        key: "プレーヤー１",
        cards: this.cards.slice(0, 4).sort((a, b) => a.index - b.index)
      },
      {
        key: "プレーヤー２",
        cards: this.cards.slice(4, 8).sort((a, b) => a.index - b.index)
      },
      {
        key: "プレーヤー３",
        cards: this.cards.slice(8, 12).sort((a, b) => a.index - b.index)
      },
      {
        key: "プレーヤー４",
        cards: this.cards.slice(12, 16).sort((a, b) => a.index - b.index)
      },
      {
        key: "伏せてあるカード",
        cards: this.cards.slice(16, 20).sort((a, b) => a.index - b.index)
      }
    ];
  }
}
